import { render } from "./PeaMenuu.vue?vue&type=template&id=5b13b5ed&ts=true"
import script from "./PeaMenuu.vue?vue&type=script&lang=ts"
export * from "./PeaMenuu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__